import React, { Component } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import styled, { css } from 'styled-components';
import SlotLabel from '../SlotLabel';
import { formatHours } from '../../../utilities/timeUtility';
import { formatAvailabilityMessage } from '../../../utilities/helperUtility';

const StyledInput = styled.input`
  ${({ style }) => {
    if (!style) return '';

    const bgc = style.body.color;
    const fs = style.body.fontSize || '16px';

    return css`
      && {
        display: none;
        + label {
          color: ${bgc};
          font-weight: bold;
          font-size: 1rem;
          cursor: pointer;
          user-select: none;
          margin-left: 5px;
          padding-left: 10px;
          padding-right: 10px;
          position: relative;

          &::before {
            transition: all 250ms cubic-bezier(0.4, 0.25, 0.3, 1);
            content: '';
            width: ${fs};
            height: ${fs};
            border-radius: 50%;
            border: 1px solid ${bgc};
            font-size: 0;
            position: absolute;
            bottom: 50%;
            left: 50%;
            transform: translate(-50%, 50%);
          }

          &::after {
            transition: all 250ms cubic-bezier(0.4, 0.25, 0.3, 1);
            content: '';
            width: 0;
            height: 0;
            border-radius: 50%;
            background-color: ${bgc};
            position: absolute;
            bottom: 50%;
            left: 50%;
            transform: translate(-50%, 50%);
          }
        }
        &:checked + label {
          &::before {
            background-color: transparent;
            width: ${fs};
            height: ${fs};
            border-width: 1px;
          }

          &::after {
            width: calc(${fs} * 0.5);
            height: calc(${fs} * 0.5);
          }
        }
      }
    `;
  }};
`;

export default class TimeSlot extends Component {
  onClick(event) {
    const { disabled, onClick, isShowWaitlist } = this.props;
    if (isShowWaitlist || !disabled) onClick(event);
  }

  render() {
    const {
      style,
      disabled,
      locale,
      timeZone,
      timeslot: {
        availability, finish, id, start,
      },
      isDisplayRange,
      isShowRemainingSpace,
      selectedTimeSlot,
      availableSpace,
      timeFormat,
      quantity,
      translation,
      variant,
    } = this.props;
    const unitMultiplier = variant?.unit_multiplier || 1;
    const available = parseInt(availableSpace / unitMultiplier, 10);
    const total = parseInt(quantity / unitMultiplier, 10);
    const variantAvailability = availability.find((x) => x.variant_id === variant.id);
    const details = variantAvailability && variantAvailability.status_detail;
    const label = details ? <SlotLabel option={{ label: '', details }} fixed={true}/> : null;

    return (
      <div
        className="pointer flexbox space-between"
        role="presentation"
        key={id}
        style={{ padding: '5px' }}
        onKeyDown={(event) => this.onClick(event)}
        onClick={(event) => this.onClick(event)}
      >
        <StyledInput
          readOnly
          type="radio"
          className="radio"
          styled={style}
          value={start}
          disabled={disabled}
          checked={selectedTimeSlot ? selectedTimeSlot.id === id : false}
        />
        <span className="flexbox vertical-center" style={{ marginRight: 'auto', marginLeft: '10px' }}>
          {formatHours(dayjs(start), locale, timeZone, timeFormat)}
          {isDisplayRange && ` - ${formatHours(dayjs(finish), locale, timeZone, timeFormat)}`}
          {isShowRemainingSpace && ` / ${formatAvailabilityMessage(available, total, translation)} `}
        </span>
        { label && <span>{label}</span> }
      </div>
    );
  }
}

TimeSlot.propTypes = {
  style: PropTypes.any,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  timeZone: PropTypes.string,
  locale: PropTypes.string,
  start: PropTypes.string,
  finish: PropTypes.string,
  isDisplayRange: PropTypes.bool,
  isShowRemainingSpace: PropTypes.bool,
  timeFormat: PropTypes.string,
  availableSpace: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
